import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const JobAlerts = () => {
  const [email, setEmail] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e?.preventDefault();
    if (email) {
      setIsSubscribed(true);
      setTimeout(() => {
        setIsSubscribed(false);
        setEmail('');
      }, 3000);
    }
  };

  return (
    <div className="bg-gradient-to-br from-primary to-secondary rounded-lg p-6 md:p-8 text-white">
      <div className="flex items-start gap-4 mb-4">
        <div className="w-12 h-12 rounded-lg bg-white/20 flex items-center justify-center flex-shrink-0">
          <Icon name="Bell" size={24} />
        </div>
        <div>
          <h3 className="text-xl md:text-2xl font-bold mb-2">
            Get Job Alerts
          </h3>
          <p className="text-sm md:text-base text-white/90">
            Never miss your dream job. Get personalized job recommendations delivered to your inbox.
          </p>
        </div>
      </div>
      {!isSubscribed ? (
        <form onSubmit={handleSubscribe} className="flex flex-col sm:flex-row gap-3">
          <Input
            type="email"
            placeholder="Enter your email address"
            value={email}
            onChange={(e) => setEmail(e?.target?.value)}
            required
            className="flex-1 bg-white/10 border-white/20 text-white placeholder:text-white/60"
          />
          <Button
            type="submit"
            variant="default"
            className="bg-white text-primary hover:bg-white/90 w-full sm:w-auto"
          >
            Subscribe
          </Button>
        </form>
      ) : (
        <div className="flex items-center gap-2 bg-white/20 rounded-lg p-4">
          <Icon name="CheckCircle2" size={20} />
          <span className="text-sm md:text-base">
            Successfully subscribed! Check your email for confirmation.
          </span>
        </div>
      )}
      <div className="flex flex-wrap gap-4 mt-6 text-xs md:text-sm text-white/80">
        <div className="flex items-center gap-2">
          <Icon name="Check" size={16} />
          <span>Daily job alerts</span>
        </div>
        <div className="flex items-center gap-2">
          <Icon name="Check" size={16} />
          <span>Personalized recommendations</span>
        </div>
        <div className="flex items-center gap-2">
          <Icon name="Check" size={16} />
          <span>Unsubscribe anytime</span>
        </div>
      </div>
    </div>
  );
};

export default JobAlerts;